import React from 'react';
import styled from 'styled-components';
import isEmpty from 'lodash/isEmpty';

const Loading = (props) => {
  const {
    text = '',
    align = 'left',
    size = 50,
    fontSize = 1.6,
    color = '#474747',
    fill = '#ee6123',
    type = 'bar',
    textStyle = {},
  } = props;

  const aligns = {
    left: 'flex-start',
    center: 'center',
    right: 'flex-end',
  };

  const svgBar = `
    <svg class="lds-equalizer" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
      <g transform="rotate(180 50 50)">
        <rect y="29"  height="13.9679" fill="#fc4309" x="6.5" width="7">
        <animate attributeName="height" calcMode="spline" values="30;45;6;30" times="0;0.33;0.66;1" keySplines="0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1" repeatCount="indefinite" begin="-0.6222222222222221s" dur="0.7"></animate>
        </rect>
        <rect y="29" height="25.0967" fill="#ff765c" x="16.5" width="7">
          <animate attributeName="height" calcMode="spline" values="30;45;6;30" times="0;0.33;0.66;1" keySplines="0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1" repeatCount="indefinite" begin="-0.15555555555555553s" dur="0.7"></animate>
        </rect>
        <rect y="29" height="37.1996" fill="#ffb646" x="26.5" width="7">
          <animate attributeName="height" calcMode="spline" values="30;45;6;30" times="0;0.33;0.66;1" keySplines="0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1" repeatCount="indefinite" begin="-0.5444444444444444s" dur="0.7"></animate>
        </rect>
        <rect y="29" height="29.9998" fill="#ff9900" x="36.5" width="7">
          <animate attributeName="height" calcMode="spline" values="30;45;6;30" times="0;0.33;0.66;1" keySplines="0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1" repeatCount="indefinite" begin="-0.2333333333333333s" dur="0.7"></animate>
        </rect>
        <rect y="29" height="41.9354" fill="#ff6600" x="46.5" width="7">
          <animate attributeName="height" calcMode="spline" values="30;45;6;30" times="0;0.33;0.66;1" keySplines="0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1" repeatCount="indefinite" begin="-0.3888888888888889s" dur="0.7"></animate>
        </rect>
        <rect y="29" height="33.0001" fill="#fc4309" x="56.5" width="7">
          <animate attributeName="height" calcMode="spline" values="30;45;6;30" times="0;0.33;0.66;1" keySplines="0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1" repeatCount="indefinite" begin="-0.31111111111111106s" dur="0.7"></animate>
        </rect>
        <rect y="29" height="6.00027" fill="#ff765c" x="66.5" width="7">
          <animate attributeName="height" calcMode="spline" values="30;45;6;30" times="0;0.33;0.66;1" keySplines="0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1" repeatCount="indefinite" begin="0s" dur="0.7"></animate>
        </rect>
        <rect y="29" height="44.9999" fill="#ffb646" x="76.5" width="7">
          <animate attributeName="height" calcMode="spline" values="30;45;6;30" times="0;0.33;0.66;1" keySplines="0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1" repeatCount="indefinite" begin="-0.4666666666666666s" dur="0.7"></animate>
        </rect>
        <rect y="29" height="10.8002" fill="#ff9900" x="86.5" width="7">
          <animate attributeName="height" calcMode="spline" values="30;45;6;30" times="0;0.33;0.66;1" keySplines="0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1" repeatCount="indefinite" begin="-0.07777777777777777s" dur="0.7"></animate>
        </rect>
      </g>
    </svg>`;

  const svgCircle = `
    <svg class="lds-spinner" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="21 21 57 57" preserveAspectRatio="xMidYMid">
      <g transform="rotate(0 50 50)">
        <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="${fill}">
          <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.7s" begin="-0.6416666666666666s" repeatCount="indefinite"></animate>
        </rect>
      </g>
      <g transform="rotate(30 50 50)">
        <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="${fill}">
          <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.7s" begin="-0.5833333333333334s" repeatCount="indefinite"></animate>
        </rect>
      </g>
      <g transform="rotate(60 50 50)">
        <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="${fill}">
          <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.7s" begin="-0.525s" repeatCount="indefinite"></animate>
        </rect>
      </g>
      <g transform="rotate(90 50 50)">
        <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="${fill}">
          <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.7s" begin="-0.4666666666666666s" repeatCount="indefinite"></animate>
        </rect>
      </g>
      <g transform="rotate(120 50 50)">
        <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="${fill}">
          <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.7s" begin="-0.40833333333333327s" repeatCount="indefinite"></animate>
        </rect>
      </g>
      <g transform="rotate(150 50 50)">
        <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="${fill}">
          <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.7s" begin="-0.3499999999999999s" repeatCount="indefinite"></animate>
        </rect>
      </g>
      <g transform="rotate(180 50 50)">
        <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="${fill}">
          <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.7s" begin="-0.2916666666666667s" repeatCount="indefinite"></animate>
        </rect>
      </g>
      <g transform="rotate(210 50 50)">
        <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="${fill}">
          <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.7s" begin="-0.2333333333333333s" repeatCount="indefinite"></animate>
        </rect>
      </g>
      <g transform="rotate(240 50 50)">
        <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="${fill}">
          <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.7s" begin="-0.17499999999999996s" repeatCount="indefinite"></animate>
        </rect>
      </g>
      <g transform="rotate(270 50 50)">
        <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="${fill}">
          <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.7s" begin="-0.11666666666666665s" repeatCount="indefinite"></animate>
        </rect>
      </g>
      <g transform="rotate(300 50 50)">
        <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="${fill}">
          <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.7s" begin="-0.05833333333333333s" repeatCount="indefinite"></animate>
        </rect>
      </g>
      <g transform="rotate(330 50 50)">
        <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="${fill}">
          <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="0.7s" begin="0s" repeatCount="indefinite"></animate>
        </rect>
      </g>
    </svg>
  `;

  return (
    <Loader align={aligns[align]} fontSize={fontSize} color={color}>
      <Svg size={size} dangerouslySetInnerHTML={{ __html: (type === 'bar') ? svgBar : svgCircle }} />
      {!isEmpty(text) && <div className="text" style={textStyle}>{text}</div>}
    </Loader>
  );
};

const Loader = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${props => props.align || 'left'};

  .text {
    font-size: ${props => props.fontSize || 1.6}rem;
    margin: 5px;
    color: ${props => props.color || '#474747'};
  }
`;

const Svg = styled.div`
  width: ${props => props.size || 50}px;
  display: flex;
  align-items: center;
`;

export default Loading;
